import CryptoJS from 'crypto-js';
export default function md5hash(input){
    if(input===""){
        return "";
    }
    let hash = CryptoJS.MD5(input);
    return hash;
}